import isObjectEmpty from "./emptyObj"

const emptyFilters = (obj) => {
    return Object.keys(obj).every(item => {
        return isObjectEmpty(obj[item])
    })
}
export default emptyFilters;